import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Form } from 'vee-validate';
import { scrollToTop } from '../../helpers/scrollToTop';
import { useOnSubmit } from '../../hooks/useOnSubmit';
import Modal from '../ui/Modal.vue';
import AddToCartButton from './AddToCartButton.vue';


export default {
  __name: 'ProductForm',
  props: {
    schema: {
        type: Object,
        required: true,
    },
    initialValues: {
        type: Object,
        required: true,
    },
    checkoutlink: { type: String, required: true },
    id: {
        type: Number,
        required: true,
    },
    price: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const { onSubmit, isSubmitting, addedToCart, addedToCartMessage } = useOnSubmit(
    props.id,
    props.checkoutlink,
);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Form), {
      "initial-values": __props.initialValues,
      "validation-schema": __props.schema,
      onInvalidSubmit: _unref(scrollToTop),
      enctype: "multipart/form-data",
      class: "erecepta-form",
      onSubmit: _unref(onSubmit),
      onKeydown: _cache[0] || (_cache[0] = _withKeys($event => ($event.preventDefault()), ["enter"]))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(AddToCartButton, {
          price: __props.price,
          isSubmitting: _unref(isSubmitting)
        }, null, 8, ["price", "isSubmitting"])
      ]),
      _: 3
    }, 8, ["initial-values", "validation-schema", "onInvalidSubmit", "onSubmit"]),
    _createVNode(Modal, {
      isOpen: _unref(addedToCart),
      onCloseModal: _cache[1] || (_cache[1] = () => (addedToCart.value = false)),
      title: _unref(addedToCartMessage),
      buttonText: "Kontynuuj",
      buttonLink: __props.checkoutlink
    }, null, 8, ["isOpen", "title", "buttonLink"])
  ], 64))
}
}

}